import _ from "lodash";
import { LOGIN_OPTION_ACCOUNT } from "../components/artefact-export-form";
import {DATAFLOW_TYPE_NORMAL} from "./dataflow";

export function isUpperCase(str)
{
    return str === str.toUpperCase() && str !== str.toLowerCase();
}

export function isDateValid(validFrom, validTo) {
  return !validFrom || !validTo || validFrom <= validTo;
}

export function isIDValidWithHelp(t, id) {

  if (/[^0-9a-z_-]/gi.test(id)) {
    return ({
      valid: false,
      help: t('validators.id.containsUnallowedChars')
    });
  } else {
    return ({valid: true});
  }
}

export function isVersionValidWithHelp(t, version) {

  const MAX_LENGTH = 10;

  if (!version || version.length === 0) {
    return ({valid: true});
  } else if (version.length > 10) { // max length 10
    return ({
      valid: false,
      help: t('validators.version.exceddsMaxLength', {maxLength: MAX_LENGTH})
    });
  } else if (version.indexOf(".") < 0) { // must contain "."
    return ({valid: false, help: t('validators.version.notContainsDot')});
  } else if (version.substr(version.length - 1) === ".") { // must not end with .
    return ({valid: false, help: t('validators.version.endsWithDot')});
  } else {

    const arr = version.split(".");

    if (arr.length > 3) { // max version depth is x.y.z
      return ({valid: false, help: t('validators.version.exceddsMaxDepth')});
    } else if (
      arr.filter(number => number === "0" || /^[1-9]([0-9]*)$/.test(number)).length !== arr.length
    ) { // each x, y, z must be 0 or a number
      return ({valid: false, help: t('validators.version.componentIsInvalid')});
    } else {
      return ({valid: true});
    }
  }
}

export function isDictionaryValid(dictionary) {
  return dictionary !== undefined && dictionary !== null &&
    _(dictionary)
      .pickBy(val => val !== undefined && val !== null && val.length > 0)
      .keys()
      .value().length > 0
}

export function isArtefactValid(artefact) {
  return !(
    artefact === null || artefact === undefined ||
    artefact.id === null || artefact.id === undefined || artefact.id.length === 0 ||
    artefact.agencyID === null || artefact.agencyID === undefined || artefact.agencyID.length === 0 ||
    artefact.version === null || artefact.version === undefined || artefact.version.length === 0 ||
    (artefact.dsd === null && artefact.dataflowType === DATAFLOW_TYPE_NORMAL) ||
    artefact.msd === null ||
    !isIDValidWithHelp(f => f, artefact.id).valid ||
    !isVersionValidWithHelp(f => f, artefact.version).valid ||
    !isDateValid(artefact.validFrom, artefact.validTo) ||
    !isDictionaryValid(artefact.name)
  );
}

export function isItemValid(item) {
  return !(
    item === null ||
    item.id === null || item.id.length === 0 ||
    !isIDValidWithHelp(f => f, item.id).valid ||
    !isDictionaryValid(item.name)
  );
}

export function isCloneDestTripletValid(cloneDestTriplet) {
  return !(
    !cloneDestTriplet ||
    cloneDestTriplet.id === null || cloneDestTriplet.id.length === 0 ||
    cloneDestTriplet.agencyID === null || cloneDestTriplet.agencyID.length === 0 ||
    cloneDestTriplet.version === null || cloneDestTriplet.version.length === 0 ||
    !isVersionValidWithHelp(f => f, cloneDestTriplet.version).valid
  );
}

export function isExportDestinationValid(exportDestination, ignoreUsername = false) {
  const validLoginOption = exportDestination.loginOption === LOGIN_OPTION_ACCOUNT 
  ? ignoreUsername === true || exportDestination.username
  : (exportDestination.providerLoginCode || "").length > 0
  return (
    exportDestination &&
    exportDestination.endpoint &&
    validLoginOption &&
    exportDestination.id &&
    exportDestination.agencyID &&
    exportDestination.version &&
    isVersionValidWithHelp(f => f, exportDestination.version).valid
  );
}

export function isYearValid(year) {
  return !year || (
    !isNaN(year) &&
    Number(year) > 1000 &&
    Number(year) < 9999
  );
}

export function isStrTripletValidWithHelp(t, str) {
  if ((str || "").length === 0) {
    return ({valid: true});
  }
  const split = str.split('+');
  if (split.length !== 3) {
    return ({
      valid: false,
      help: t('validators.triplet.wrongNumberElements')
    });
  };
    
  const id = split[0];
  const agencyID = split[1];
  const version = split[2];

  const idIsValid = isIDValidWithHelp(t, id);
  if (!idIsValid.valid) {
    return ({
      valid: false,
      help: `id: ${idIsValid.help}`
    });
  }

  const agencyIDIsValid = isIDValidWithHelp(t, agencyID);
  if (!agencyIDIsValid.valid) {    
    return ({
      valid: false,
      help: `agencyID: ${agencyIDIsValid.help}`
    });
  };

  const versionIsValid = isVersionValidWithHelp(t, version);
  if (!versionIsValid.valid) {
    return ({
      valid: false,
      help: `version: ${versionIsValid.help}`
    });
  };

  return ({valid: true});

}


// WEBPACK FOOTER //
// ./src/utils/artefactValidators.js